/* eslint-disable max-len */
import React from 'react';
import { get, orderBy } from 'lodash';
import { util } from 'veritone-redux-common';
import { arrayOf, shape, string, func } from 'prop-types';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import InstructionCard from './InstructionCard';
import NewClusterDialog from './NewClusterDialog';
import ClusterTable from './ClusterTable';
import checkIcon from 'resources/images/check-note.png';
import laptopIcon from 'resources/images/laptop.png';

// redux
import {
  getClusters,
  createClusterService,
  deleteClusterService
} from 'modules/aiWare';
import { selectUser } from 'modules/user';
import rootSaga from '../modules/saga';

import styles from './styles/index.scss';

const saga = util.reactReduxSaga.saga;

@saga(rootSaga)
@connect(
  (state, ownProps) => ({
    clusters: getClusters(state),
    userInfo: selectUser(state)
  }),
  dispatch => ({
    createNewCluster: ({ name, organizationId }) =>
      dispatch(createClusterService({ name, organizationId })),
    deleteCluster: id => dispatch(deleteClusterService(id))
  })
)
export default class AiWare extends React.Component {
  static propTypes = {
    clusters: arrayOf(
      shape({
        id: string,
        name: string,
        createdDateTime: string,
        status: string
      })
    ),
    createNewCluster: func,
    deleteCluster: func,
    userInfo: shape({})
  };

  state = {
    openDialog: false
  };

  handleOpenDialog = () => {
    this.setState({
      openDialog: true
    });
  };

  handleCloseDialog = () => {
    this.setState({
      openDialog: false
    });
  };

  render() {
    const { createNewCluster, deleteCluster, userInfo, clusters } = this.props;
    const { openDialog } = this.state;

    const sortedClusters = orderBy(clusters, ['createdDateTime'], ['desc']);
    const organizationId = get(userInfo, 'organization.organizationId', '');

    return (
      <div className={styles.overviewContainer}>
        <NewClusterDialog
          open={openDialog}
          onClose={this.handleCloseDialog}
          onSubmit={createNewCluster}
          organizationId={organizationId}
        />
        <Typography variant="h4" gutterBottom>
          aiWARE Private Deployments
        </Typography>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          aiWARE allows you to create private clusters with your own
          infrastructure. Private clusters are great for running AI engines
          without uploading the raw data to the Veritone SaaS cloud. Watch the
          demo to learn more.
        </Typography>
        {/* <div className={styles.videoContainer}>
          <video
            src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
            controls
            width={500}
          />
        </div> */}
        <InstructionCard
          headerText="How to Create a New aiWARE Cluster?"
          contentText="Click here to learn how to install, configure and validate an instance of aiWARE for use on your own infrastructure."
          img={checkIcon}
          referenceLink="https://docs.veritone.com/#/"
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            margin: '20px 0'
          }}
        >
          <Typography variant="h5" color="textSecondary" gutterBottom>
            aiWARE Private Deployments
          </Typography>
          <Button
            color="primary"
            variant="outlined"
            onClick={this.handleOpenDialog}
          >
            Connect New Cluster
          </Button>
        </div>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          Your clusters can either run standalone or connect to the aiWARE SaaS
          cloud. In connected mode, you will be able to utilize aiWARE&apos;s
          multi-variant cognitive search as well as a collection of UI and API
          based intefraces. To learn more about hybrid deployments, click here.
        </Typography>
        <ClusterTable data={sortedClusters} onDeleteCluster={deleteCluster} />
        <InstructionCard
          headerText="How to Update and Troubleshoot aiWARE Clusters?"
          contentText="Click here to learn how update private aiWARE deployments, install engines, run processing, and troubleshoot."
          img={laptopIcon}
          referenceLink="https://docs.veritone.com/#/"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/aiware/components/AiWare.js